import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { investorsData } from './investorsData'
import { InvestorsBlockCard } from './InvestorsBlockCard'
import classes from './InvestorsBlock.module.scss'

export const InvestorsBlock = ({ className }: { className?: string }) => {
  return (
    <Block as={'section'} variant={'solid'} pad={'base'} className={className}>
      <Heading as={'h2'} center balance size={'xl'} className={classes.title}>
        Backed by experts in SaaS and AI
      </Heading>

      <ul className={classes.list}>
        {investorsData.map((item, index) => (
          <InvestorsBlockCard key={index} item={item} />
        ))}
      </ul>
    </Block>
  )
}
